<script>
  import { inertia } from "@inertiajs/svelte";
</script>

<a
  href={route("help")}
  use:inertia
  class="btn btn-outline-primary float-end btn-sm mt-2"
  ><i class="bi bi-question-circle"></i> Additional Help</a
>
